import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import ProjectList from './components/ProjectList';
import HouseList from './components/HouseList';
import TaskList from './components/TaskList';
import { AppBar, Toolbar, Typography, Container, Button } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" style={{ flexGrow: 1 }}>
              Project Tracker Dashboard
            </Typography>
            <Button color="inherit" component={Link} to="/">
              <HomeIcon /> Home
            </Button>
            <Button color="inherit" component={Link} to="/projects">
              Projects
            </Button>
          </Toolbar>
        </AppBar>
        <Container style={{ marginTop: '20px' }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/projects" element={<ProjectList />} />
            <Route path="/projects/:projectId/houses" element={<HouseList />} />
            <Route path="/houses/:houseId/tasks" element={<TaskList />} />
          </Routes>
        </Container>
      </div>
    </Router>
  );
}

export default App;